import { render } from "./AddPost.vue?vue&type=template&id=3c311ce1&scoped=true"
import script from "./AddPost.vue?vue&type=script&lang=js"
export * from "./AddPost.vue?vue&type=script&lang=js"

import "./AddPost.vue?vue&type=style&index=0&id=3c311ce1&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3c311ce1"]])

export default __exports__